import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Scroll from 'react-scroll';
import { useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers, faTasks, faTachometer, faPlus, faEye, faLungs, faCheckCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import { useRecoilState } from 'recoil';

import { topAlertMessageState, topAlertStatusState, userDetailState } from "../../../../AppState";
import { putSessionUpdateAPI } from "../../../../API/Session";
import { getSessionDetailAPI } from "../../../../API/Session";
import FormErrorBox from "../../../Reusable/FormErrorBox";
import FormInputField from "../../../Reusable/FormInputField";
import FormTextareaField from "../../../Reusable/FormTextareaField";
import FormListInputField from "../../../Reusable/FormListInputField";
import FormSelectField from "../../../Reusable/FormSelectField";
import PickCMSImageModal from "../../../Reusable/PickCMSImageModal";
import PickCMSVideoModal from "../../../Reusable/PickCMSVideoModal";
import FormInputFieldWithButton from "../../../Reusable/FormInputFieldWithButton";
import { BREATHWORK_TYPE_WITH_EMPTY_OPTIONS } from "../../../../Constants/FieldOptions";


function UserSessionBreathworkOptionAdd() {
    ////
    //// URL parameters.
    ////

    const { sid, uid } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);
    const [user, setUser] = useRecoilState(userDetailState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [isFetching, setFetching] = useState(false);
    const [forceURL, setForceURL] = useState("");
    const [session, setSession] = useState({});
    const [name, setName] = useState();
    const [maxMins, setMaxMins] = useState(0);
    const [instructions, setInstructions] = useState();
    const [inhaleHold, setInhaleHold] = useState();
    const [inhale, setInhale] = useState();
    const [exhaleHold, setExhaleHold] = useState();
    const [exhale, setExhale] = useState();
    const [description, setDescription] = useState();
    const [breathworkType, setBreathworkType] = useState("");
    const [backgroundVideoURL, setBackgroundVideoURL] = useState();
    // const [pickImageModalIsVisible, setPickCMSImageModalIsVisible] = useState(false);ç
    const [pickBackgroundVideoURLModalIsVisible, setPickBackgroundVideoURLModalIsVisible] = useState(false);

    ////
    //// Event handling.
    ////

    const onSubmitClick = (e) => {
        console.log("onSubmitClick: Beginning...");
        const breahworkQuestion = {
            name: name,
            maxMins: parseInt(maxMins),
            instructions: instructions,
            inhaleHold: parseInt(inhaleHold),
            inhale: parseInt(inhale),
            exhaleHold: parseInt(exhaleHold),
            exhale: parseInt(exhale),
            description: description,
            breathworkType: breathworkType,
            backgroundVideoUrl: backgroundVideoURL,
        };

        // Defensive code. If the breathwork options array was not defined previously.
        if (session["breathworkOptions"] === undefined || session["breathworkOptions"] === null || session["breathworkOptions"] === "") {
            session["breathworkOptions"] = [];
        }

        console.log("onSubmitClick: Adding to breathwork option to array...");
        session["breathworkOptions"].push(breahworkQuestion);

        console.log("onSubmitClick: Payload:", session);

        console.log("onSubmitClick: Please wait");
        putSessionUpdateAPI(session, onSessionUpdateSuccess, onSessionUpdateError, onSessionUpdateDone);
    }

    const onInstructionsChange = (e, i) => {
        // For debugging purposes.
        console.log(e, i);

        // Make a copy of the "array of strings" into a mutable array.
        const copyOfArr = [...instructions];

        // Update record.
        copyOfArr[i] = e

        // Save to our react state.
        setInstructions(copyOfArr);
    }

    const onRemoveListInputFieldChange = (i) => {
        // For debugging purposes.
        console.log(i);

        // Make a copy of the "array of strings" into a mutable array.
        const copyOfArr = [...instructions];

        // Delete record.
        const x = copyOfArr.splice(i, 1);

        // For debugging purposes.
        console.log(x);

        // Save to our react state.
        setInstructions(copyOfArr);
    }

    const onAddListInputFieldClick = () => {
        // For debugging purposes.
        console.log("add");

        // Make a copy of the "array of strings" into a mutable array.
        let copyOfArr = [];
        if (instructions && instructions.length > 0) { // Defensive code.
            copyOfArr = [...instructions];
        }

        // Add empty record.
        copyOfArr.push("");

        // For debugging purposes.
        console.log(copyOfArr);

        // Save to our react state.
        setInstructions(copyOfArr);
    }

    // const onCMSImagePicked = (img) => {
    //     console.log("onCMSImagePicked:", img);
    //     if (img !== undefined && img !== null && img !== "") {
    //         setPreviewImageUrl(img.publicObjectUrl);
    //     }
    //     setPickCMSImageModalIsVisible(false);
    // }

    const onBackgroundVideoURLPicked = (v) => {
        console.log("onBackgroundVideoURLPicked:", v);
        if (v !== undefined && v !== null && v !== "") {
            setBackgroundVideoURL(v.m3u8PublicObjectUrl);
        }
        setPickBackgroundVideoURLModalIsVisible(false);
    }

    ////
    //// API.
    ////

    function onSessionDetailSuccess(response){
        console.log("onSessionDetailSuccess: Starting...");
        console.log("onSessionDetailSuccess: data:", response);
        setSession(response);
    }

    function onSessionDetailError(apiErr) {
        console.log("onSessionDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionDetailDone() {
        console.log("onSessionDetailDone: Starting...");
        setFetching(false);
    }

    function onSessionUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Video section created");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Redirect the user to a new page.
        setForceURL("/user/" + uid + "/session/" + sid + "/breathwork-options");
    }

    function onSessionUpdateError(apiErr) {
        console.log("onSessionUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionUpdateError: Delayed for 2 seconds.");
            console.log("onSessionUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();

        // Reload the session upon errors.
        setFetching(true);
        getSessionDetailAPI(
            sid,
            onSessionDetailSuccess,
            onSessionDetailError,
            onSessionDetailDone
        );
    }

    function onSessionUpdateDone() {
        console.log("onSessionUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionDetailAPI(
                sid,
                onSessionDetailSuccess,
                onSessionDetailError,
                onSessionDetailDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            {/*
                <PickCMSImageModal
                    isVisible={pickImageModalIsVisible}
                    setIsVisible={setPickCMSImageModalIsVisible}
                    onClick={onCMSImagePicked}
                />

            */}
            <PickCMSVideoModal
                modalTitle={"Pick Background Video"}
                isVisible={pickBackgroundVideoURLModalIsVisible}
                setIsVisible={setPickBackgroundVideoURLModalIsVisible}
                onClick={onBackgroundVideoURLPicked}
            />
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/users" aria-current="page"><FontAwesomeIcon className="fas" icon={faUsers} />&nbsp;Users</Link></li>
                            <li class=""><Link to={`/user/${uid}/sessions`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Sessions)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/breathwork-options`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Breathwork Options)</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;New</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/breathwork-options`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Detail (Breathwork Options)</Link></li>
                        </ul>
                    </nav>

                    {/* Page */}
                    <nav class="box">
                        <p class="title is-4"><FontAwesomeIcon className="fas" icon={faLungs} />&nbsp;Breathwork Option - {user.firstName} {user.lastName}</p>
                        <FormErrorBox errors={errors} />

                        <p class="subtitle is-6">Details</p>

                        {isFetching && <div class="columns is-centered" style={{paddingTop: "20px"}}>
                            <div class="column has-text-centered is-2">
                            <div class="loader-wrapper is-centered">
                              <div class="loader is-loading is-centered" style={{height: "80px", width: "80px"}}></div>
                            </div>
                            </div>
                        </div>}

                        {!isFetching && <div class="container">
                            <FormInputField
                                label="Name"
                                name="name"
                                type="text"
                                placeholder="Text input"
                                value={name}
                                errorText={errors && errors.name}
                                helpText=""
                                onChange={(e)=>setName(e.target.value)}
                                isRequired={true}
                                maxWidth="185px"
                            />

                            <FormInputField
                                label="Max Mins (Optional)"
                                name="maxMins"
                                type="number"
                                placeholder="#"
                                value={maxMins}
                                errorText={errors && errors.maxMins}
                                helpText=""
                                onChange={(e)=>setMaxMins(e.target.value)}
                                isRequired={true}
                                maxWidth="185px"
                            />

                            <FormListInputField
                                label="Instructions"
                                name="instructions"
                                type="text"
                                placeholder="Text input"
                                value={instructions}
                                errorText={errors && errors.instructions}
                                helpText=""
                                onListInputFieldChange={onInstructionsChange}
                                onRemoveListInputFieldChange={onRemoveListInputFieldChange}
                                onAddListInputFieldClick={onAddListInputFieldClick}
                                isRequired={true}
                                maxWidth="100%"
                            />

                            <FormInputField
                                label="Inhale Hold (Optional)"
                                name="inhaleHold"
                                type="number"
                                placeholder="#"
                                value={inhaleHold}
                                errorText={errors && errors.inhaleHold}
                                helpText=""
                                onChange={(e)=>setInhaleHold(e.target.value)}
                                isRequired={true}
                                maxWidth="185px"
                            />

                            <FormInputField
                                label="Inhale (Optional)"
                                name="inhale"
                                type="number"
                                placeholder="#"
                                value={inhale}
                                errorText={errors && errors.inhale}
                                helpText=""
                                onChange={(e)=>setInhale(e.target.value)}
                                isRequired={true}
                                maxWidth="185px"
                            />

                            <FormInputField
                                label="Exhale Hold (Optional)"
                                name="exhaleHold"
                                type="number"
                                placeholder="#"
                                value={exhaleHold}
                                errorText={errors && errors.exhaleHold}
                                helpText=""
                                onChange={(e)=>setExhaleHold(e.target.value)}
                                isRequired={true}
                                maxWidth="185px"
                            />

                            <FormInputField
                                label="Exhale (Optional)"
                                name="exhale"
                                type="number"
                                placeholder="#"
                                value={exhale}
                                errorText={errors && errors.exhale}
                                helpText=""
                                onChange={(e)=>setExhale(e.target.value)}
                                isRequired={true}
                                maxWidth="185px"
                            />

                            <FormTextareaField
                                label="Description"
                                name="description"
                                placeholder="Text input"
                                value={description}
                                errorText={errors && errors.description}
                                helpText=""
                                onChange={(e)=>setDescription(e.target.value)}
                                isRequired={true}
                                maxWidth="100%"
                                rows={4}
                            />

                            <FormSelectField
                                label="Breathwork Type"
                                name="breathworkType"
                                placeholder="Pick"
                                selectedValue={breathworkType}
                                errorText={errors && errors.breathworkType}
                                helpText=""
                                onChange={(e)=>setBreathworkType(e.target.value)}
                                options={BREATHWORK_TYPE_WITH_EMPTY_OPTIONS}
                            />

                            {/*
                            <FormInputFieldWithButton
                                label="Preview Image URL"
                                name="previewImageUrl"
                                type="text"
                                placeholder="Text input"
                                value={previewImageUrl}
                                errorText={errors && errors.previewImageUrl}
                                helpText=""
                                onChange={(e)=>setPreviewImageUrl(e.target.value)}
                                isRequired={true}
                                disabled={false}
                                maxWidth="100%"
                                buttonLabel={"Select Image URL"}
                                onButtonClick={(e)=>setPickCMSImageModalIsVisible(!pickImageModalIsVisible)}
                            />
                            */}

                            <FormInputFieldWithButton
                                label="Background Video URL"
                                name="backgroundVideoURL"
                                type="text"
                                placeholder="Text input"
                                value={backgroundVideoURL}
                                errorText={errors && errors.backgroundVideoUrl}
                                helpText=""
                                onChange={(e)=>setBackgroundVideoURL(e.target.value)}
                                isRequired={true}
                                maxWidth="100%"
                                buttonLabel={"Select Video"}
                                onButtonClick={(e)=>setPickBackgroundVideoURLModalIsVisible(!pickBackgroundVideoURLModalIsVisible)}
                            />

                            <div class="columns">
                                <div class="column is-half">
                                    <Link to={`/user/${uid}/session/${sid}/breathwork-options`} class="button is-hidden-touch"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                    <Link to={`/user/${uid}/session/${sid}/breathwork-options`} class="button is-fullwidth is-hidden-desktop"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                </div>
                                <div class="column is-half has-text-right">
                                    <button class="button is-primary is-hidden-touch" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                    <button class="button is-primary is-fullwidth is-hidden-desktop" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                </div>
                            </div>

                        </div>}
                    </nav>
                </section>
            </div>
        </>
    );
}

export default UserSessionBreathworkOptionAdd;
